import { RadioField, SubmitButton } from "components/form";
import { ButtonLevel } from "components/ui/Button";
import UILabel from "components/ui/UILabel";
import React from "react";
import { useFormState } from "react-hook-form";
import styled from "styled-components";
import { RADIO_OPTIONS } from "./constants";

const LabelWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label: React.FC<{
  heading: string;
  body: string;
}> = ({ heading, body }) => (
  <LabelWrapper>
    <UILabel.Large bold>{heading}</UILabel.Large>
    <UILabel.Medium>{body}</UILabel.Medium>
  </LabelWrapper>
);

const Form: React.FC<{ isSuccess: boolean }> = ({ isSuccess }) => {
  const { isDirty } = useFormState();

  return (
    <>
      <RadioField
        name="transactionSource"
        options={RADIO_OPTIONS.map(({ value, heading, body }) => ({
          value,
          label: <Label heading={heading} body={body} />,
        }))}
      />

      <SubmitButton
        level={ButtonLevel.cta}
        disabled={!isDirty}
        isSuccess={isSuccess && !isDirty}
        successMessage="Updated!"
      >
        Update
      </SubmitButton>
    </>
  );
};

export default Form;
